import { AppStateModel } from "../app-state.model";
import { createSelector } from "@ngrx/store";
import { SelectedVariablesModel } from "./selected-variables.reducer";

export const selectVariablesFeature = (state: AppStateModel) => state.selectedVariables;
export const selectAnimalId =
  createSelector(selectVariablesFeature, (state: SelectedVariablesModel) => state.animalId);
export const selectLatestToS =
  createSelector(selectVariablesFeature, (state: SelectedVariablesModel) => state.latestToS);
